import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, RadarController } from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, RadarController);

const CandidateAttemptRadarChart = ({ data }) => {
    const { title, color, top_four_scores, endUserScore } = data;

    if (!title || !color || !top_four_scores || !endUserScore) {
        console.log('Missing required props:', { title, color, top_four_scores, endUserScore });
        return <div style={{ width: 200, height: 200, opacity: 0 }}> - </div>;
    };

    let capitalizedRadarData = [title, ...Object.keys(top_four_scores)]?.map(
        score => score?.charAt(0)?.toUpperCase() + score?.slice(1)
    );

    function LightenDarkenColor(col, amt) {
        var usePound = false;
        if (col[0] == "#") {
            col = col.slice(1);
            usePound = true;
        }

        var num = parseInt(col, 16);

        var r = (num >> 16) + amt;

        if (r > 255) r = 255;
        else if (r < 0) r = 0;

        var b = ((num >> 8) & 0x00FF) + amt;

        if (b > 255) b = 255;
        else if (b < 0) b = 0;

        var g = (num & 0x0000FF) + amt;

        if (g > 255) g = 255;
        else if (g < 0) g = 0;

        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }

    const radarData = {
        labels: capitalizedRadarData,
        datasets: [
            {
                label: '',
                data: [endUserScore, ...Object.values(top_four_scores)],
                backgroundColor: function (context) {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    if (!chartArea) return color;

                    const gradient = ctx.createLinearGradient(0, 0, 400, 400);
                    gradient.addColorStop(0, color);
                    gradient.addColorStop(1, LightenDarkenColor(color, 100));
                    return gradient;
                },
                borderColor: color ? color : 'rgba(34, 202, 236, 1)',
                borderWidth: 0,
                pointRadius: 0,
                fill: true
            },
        ],
    };

    const radarOptions = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                mode: 'nearest',
                intersect: false,
            },
        },
        scales: {
            r: {
                beginAtZero: true,
                max: 90,
                min: 20,
                ticks: {
                    display: false,
                },
                pointLabels: {
                    font: {
                        size: 15,
                    },
                    color: '#2D2D2D',
                },
            },
        },
    };

    return (
        <div style={{ height: 300, width: 450, position: 'relative', maxWidth: '100%', margin: '0 auto' }}>
            <Radar data={radarData} options={radarOptions} />
        </div>
    );

};

export default CandidateAttemptRadarChart;